// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: {
    production: 'https://apisidumas.badungkab.dev/api/admin/',
    demo: 'https://apisidumas.badungkab.dev/api/admin/',
    prod_path: 'https://apisidumas.badungkab.dev/',
    demo_path: 'https://apisidumas.badungkab.dev/',
  },
  live: {
    api_url: 'https://apisidumas.badungkab.dev/api/admin/',
    public_url: 'https://apisidumas.badungkab.dev/api/',
    path_url: 'https://apisidumas.badungkab.dev/',
    share_url: 'https://kontakbupati.badungkab.dev/pengaduan/share/',
  },
  demo: {
    api_url: 'https://apisidumas.badungkab.dev/api/admin/',
    public_url: 'https://apisidumas.badungkab.dev/api/',
    path_url: 'https://apisidumas.badungkab.dev/',
    share_url: 'https://kontakbupati.badungkab.dev/pengaduan/share/',
  },
  googleMapsApiKey: 'AIzaSyAovhxjkjJX16jhgBhuFGJTlIdfJZ8uYCY',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
